var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, useFormioContext } from '@formio/react';
import { useEffect, useState } from 'react';
const getFormAccessForm = (roles) => ({
    display: 'form',
    components: [
        {
            type: 'container',
            key: 'submissionAccess',
            components: [
                {
                    label: '<b>Read Own Submissions</b>',
                    labelPosition: 'left-left',
                    widget: 'choicesjs',
                    tableView: true,
                    multiple: true,
                    dataSrc: 'values',
                    data: {
                        values: roles.map((role) => ({
                            label: role.title,
                            value: role._id,
                        })),
                    },
                    idPath: '_id',
                    template: '<span>{{ item.label }}</span>',
                    key: 'read_own',
                    type: 'select',
                    disableLimit: false,
                    noRefreshOnScroll: false,
                    input: true,
                },
                {
                    label: '<b>Update Own Submissions</b>',
                    labelPosition: 'left-left',
                    widget: 'choicesjs',
                    tableView: true,
                    multiple: true,
                    dataSrc: 'values',
                    data: {
                        values: roles.map((role) => ({
                            label: role.title,
                            value: role._id,
                        })),
                    },
                    key: 'update_own',
                    template: '<span>{{ item.label }}</span>',
                    type: 'select',
                    disableLimit: false,
                    noRefreshOnScroll: false,
                    input: true,
                },
                {
                    label: '<b>Delete Own Submissions</b>',
                    labelPosition: 'left-left',
                    widget: 'choicesjs',
                    tableView: true,
                    multiple: true,
                    dataSrc: 'values',
                    template: '<span>{{ item.label }}</span>',
                    data: {
                        values: roles.map((role) => ({
                            label: role.title,
                            value: role._id,
                        })),
                    },
                    key: 'delete_own',
                    type: 'select',
                    disableLimit: false,
                    noRefreshOnScroll: false,
                    input: true,
                },
                {
                    label: '<b>Read All Submissions</b>',
                    labelPosition: 'left-left',
                    widget: 'choicesjs',
                    tableView: true,
                    multiple: true,
                    dataSrc: 'values',
                    template: '<span>{{ item.label }}</span>',
                    data: {
                        values: roles.map((role) => ({
                            label: role.title,
                            value: role._id,
                        })),
                    },
                    key: 'read_all',
                    type: 'select',
                    disableLimit: false,
                    noRefreshOnScroll: false,
                    input: true,
                },
                {
                    label: '<b>Update All Submissions</b>',
                    labelPosition: 'left-left',
                    widget: 'choicesjs',
                    tableView: true,
                    multiple: true,
                    dataSrc: 'values',
                    template: '<span>{{ item.label }}</span>',
                    data: {
                        values: roles.map((role) => ({
                            label: role.title,
                            value: role._id,
                        })),
                    },
                    key: 'update_all',
                    type: 'select',
                    disableLimit: false,
                    noRefreshOnScroll: false,
                    input: true,
                },
                {
                    label: '<b>Delete All Submissions</b>',
                    labelPosition: 'left-left',
                    widget: 'choicesjs',
                    template: '<span>{{ item.label }}</span>',
                    tableView: true,
                    multiple: true,
                    dataSrc: 'values',
                    data: {
                        values: roles.map((role) => ({
                            label: role.title,
                            value: role._id,
                        })),
                    },
                    key: 'delete_all',
                    type: 'select',
                    disableLimit: false,
                    noRefreshOnScroll: false,
                    input: true,
                },
            ],
        },
        {
            type: 'container',
            key: 'access',
            components: [
                {
                    label: '<b>Read Own Forms</b>',
                    labelPosition: 'left-left',
                    widget: 'choicesjs',
                    tableView: true,
                    multiple: true,
                    dataSrc: 'values',
                    data: {
                        values: roles.map((role) => ({
                            label: role.title,
                            value: role._id,
                        })),
                    },
                    idPath: '_id',
                    template: '<span>{{ item.label }}</span>',
                    key: 'read_own',
                    type: 'select',
                    disableLimit: false,
                    noRefreshOnScroll: false,
                    input: true,
                },
                {
                    label: '<b>Update Own Forms</b>',
                    labelPosition: 'left-left',
                    widget: 'choicesjs',
                    tableView: true,
                    multiple: true,
                    dataSrc: 'values',
                    data: {
                        values: roles.map((role) => ({
                            label: role.title,
                            value: role._id,
                        })),
                    },
                    template: '<span>{{ item.label }}</span>',
                    key: 'update_own',
                    type: 'select',
                    disableLimit: false,
                    noRefreshOnScroll: false,
                    input: true,
                },
                {
                    label: '<b>Delete Own Forms</b>',
                    labelPosition: 'left-left',
                    widget: 'choicesjs',
                    tableView: true,
                    multiple: true,
                    dataSrc: 'values',
                    data: {
                        values: roles.map((role) => ({
                            label: role.title,
                            value: role._id,
                        })),
                    },
                    template: '<span>{{ item.label }}</span>',
                    key: 'delete_own',
                    type: 'select',
                    disableLimit: false,
                    noRefreshOnScroll: false,
                    input: true,
                },
                {
                    label: '<b>Read All Forms</b>',
                    labelPosition: 'left-left',
                    widget: 'choicesjs',
                    tableView: true,
                    multiple: true,
                    dataSrc: 'values',
                    data: {
                        values: roles.map((role) => ({
                            label: role.title,
                            value: role._id,
                        })),
                    },
                    template: '<span>{{ item.label }}</span>',
                    key: 'read_all',
                    type: 'select',
                    disableLimit: false,
                    noRefreshOnScroll: false,
                    input: true,
                },
                {
                    label: '<b>Update All Forms</b>',
                    labelPosition: 'left-left',
                    widget: 'choicesjs',
                    tableView: true,
                    multiple: true,
                    dataSrc: 'values',
                    data: {
                        values: roles.map((role) => ({
                            label: role.title,
                            value: role._id,
                        })),
                    },
                    template: '<span>{{ item.label }}</span>',
                    key: 'update_all',
                    type: 'select',
                    disableLimit: false,
                    noRefreshOnScroll: false,
                    input: true,
                },
                {
                    label: '<b>Delete All Forms</b>',
                    labelPosition: 'left-left',
                    widget: 'choicesjs',
                    tableView: true,
                    multiple: true,
                    dataSrc: 'values',
                    data: {
                        values: roles.map((role) => ({
                            label: role.title,
                            value: role._id,
                        })),
                    },
                    template: '<span>{{ item.label }}</span>',
                    key: 'delete_all',
                    type: 'select',
                    disableLimit: false,
                    noRefreshOnScroll: false,
                    input: true,
                },
            ],
        },
        {
            type: 'button',
            label: 'Save Settings',
            key: 'saveSettings',
            input: true,
            tableView: false,
            customClass: 'button save-access',
            action: 'event',
            event: 'saveSettings',
        },
    ],
});
const fetchRoles = (token) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch('/role', {
        headers: {
            'x-jwt-token': token,
        },
    });
    if (!response.ok) {
        throw new Error(yield response.text());
    }
    return response.json();
});
const mapAccessToSubmission = (access) => {
    return access.reduce((acc, { type, roles }) => {
        acc[type] = roles.map((id) => id);
        return acc;
    }, {});
};
export const FormAccess = ({ id }) => {
    const { token, Formio } = useFormioContext();
    const [formAccess, setFormAccess] = useState();
    const [submissionAccess, setSubmissionAccess] = useState();
    const [roles, setRoles] = useState(null);
    useEffect(() => {
        const fetchFormRolesAndAccessSettings = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const formio = new Formio(`/form/${id}`);
                const formPromise = formio.loadForm();
                const rolesPromise = fetchRoles(token);
                const [form, roles] = yield Promise.all([formPromise, rolesPromise]);
                setRoles(roles);
                setFormAccess(form.access);
                setSubmissionAccess(form.submissionAccess);
            }
            catch (err) {
                console.error('Error while loading form access:', err);
            }
        });
        fetchFormRolesAndAccessSettings();
    }, [Formio, id, token]);
    const handleCustomEvent = (_a) => __awaiter(void 0, [_a], void 0, function* ({ type, data }) {
        if (type === 'saveSettings') {
            try {
                const formio = new Formio(`/form/${id}`);
                const form = yield formio.loadForm();
                const updatedAccess = Object.entries(data.access).map(([type, roles]) => ({
                    type,
                    roles,
                }));
                const updatedSubmissionAccess = Object.entries(data.submissionAccess).map(([type, roles]) => ({
                    type,
                    roles,
                }));
                yield formio.saveForm(Object.assign(Object.assign({}, form), { access: updatedAccess, submissionAccess: updatedSubmissionAccess }));
                setFormAccess(updatedAccess);
                setSubmissionAccess(updatedSubmissionAccess);
            }
            catch (err) {
                console.error('Error while saving form access:', err);
            }
        }
    });
    return (_jsx("div", { className: "panel access active", children: _jsxs("div", { className: "form-access-wrap", children: [_jsx("div", { className: "comp-inside-box yellow", children: _jsxs("p", { children: ["User Permissions allow you to control who can create, view, and modify form submissions. Here you may assign Project Roles to permissions. ", _jsx("span", { className: "strong", children: "Roles" }), ' ', "can be created and edited in the ", _jsx("span", { className: "strong", children: "default template" }), " file."] }) }), _jsx("div", { className: "form-perms-wrap", children: (roles === null || roles === void 0 ? void 0 : roles.length) && formAccess && submissionAccess ? (_jsx(Form, { src: getFormAccessForm(roles), submission: {
                            data: {
                                access: mapAccessToSubmission(formAccess),
                                submissionAccess: mapAccessToSubmission(submissionAccess),
                            },
                        }, onCustomEvent: handleCustomEvent })) : (_jsx("p", { children: "Loading..." })) })] }) }));
};
